<div class="row whitelist-item" [ngClass]="headerClass(step)">
  <div class="col-lg-6 pull-left">
    <strong>{{ step.nr }} - {{ step.text }}</strong>
  </div>
  <div class="col-lg-6 pull-right">
    @if (!step.lock_text && step.state === 1) {
      <div>Nächster Schritt</div>
    }
    @if (!step.lock_text && step.state === 2) {
      <div>AKTIV</div>
    }
    @if (step.lock_text) {
      <div>GESPERRT</div>
    }
  </div>
</div>

<div class="row whitelist-item" [ngClass]="{'whitelist-item-default': step.state === 0||step.state === 3}">
  <div class="col-lg-4">
    @if (step.start_date) {
      <div>Angemeldet: {{ step.start_date }} - {{ step.start_user }}</div>
    }
    @if (step.end_date) {
      <div>Abgemeldet: {{ step.end_date }} - {{ step.end_user }}</div>
    }
    @if (step.time) {
      <div>Dauer: {{ step.time }}</div>
    }
  </div>

  <div class="col-lg-4">
    @if (step.production_step_id === 37) {
      <div>
        <business-order-film-inventory [filmInventory]="filmInventory">
        </business-order-film-inventory>
      </div>
    }
    @for (line of step.article_field; track $index) {
      <div>
        <div [innerHTML]="line"></div>
      </div>
    }
    @if (step.article_field.length === 0) {
      <div>&nbsp;</div>
    }
  </div>

  @if (step.end_date) {
    <div class="col-lg-4">
      <div>Gutstück: {{ step.good_piece }}</div>
      <div>Ausschuss: {{ step.wastrel }}</div>
    </div>
  }
</div>

<div class="row whitelist-item">
  <div class="col-lg-4">
    @if (step.info_text) {
      <div><strong>Information:</strong></div>
    }
    @if (step.info_text) {
      <div>{{ step.info_text }}</div>
    }
    @if (!step.info_text) {
      <div>&nbsp;</div>
    }
  </div>
  <div class="col-lg-4">
    @if (step.lock_text) {
      <div><strong>Sperrtext:</strong></div>
    }
    @if (step.lock_text) {
      <div>{{ step.lock_text }}</div>
    }
    @if (!step.lock_text) {
      <div>&nbsp;</div>
    }
  </div>
  <div class="col-lg-4">&nbsp;</div>
</div>

@if (mergeButtonsVisible) {
  <div class="row whitelist-item">
    @if (reproduction?.step_ordering !== step.ordering) {
      <div class="col-lg-8">&nbsp;</div>
    }
    @if (reproduction?.step_ordering === step.ordering) {
      <div class="col-lg-4">&nbsp;</div>
    }
    @if (reproduction?.step_ordering === step.ordering) {
      <div class="col-lg-4 align-center">
        @if ((!stepPrevious || (stepPrevious.state > 2))) {
          <button type="button"
            ngbTooltip="Führt die Nachfertigung mit dem Haupt BA zusammen"
            class="btn btn-danger btn-sm"
            (click)="openMergeModal()"
            >
            Nachfertigung zusammenfügen
          </button>
        }
      </div>
    }
    @if (!('ba.reproduction.merge'|HasPerm)) {
      <div class="col-lg-4">
        <div class="red-font">Zusammenführungspunkt mit Haupt-BA</div>
      </div>
    }
    @if (('ba.reproduction.merge'|HasPerm)) {
      <div class="col-lg-4">
        @if (reproduction?.step_ordering !== step.ordering) {
          <button type="button"
            class="btn btn-default btn-sm pull-right"
            [ngbTooltip]="toolTipText"
            (click)="selectMergeStep()"
            >
            als Zusammenfügungspunkt wählen
          </button>
        }
        @if (reproduction?.step_ordering === step.ordering) {
          <button type="button"
            ngbTooltip="Zusammenfügung in diesem Schritt abbrechen"
            class="btn btn-danger btn-sm pull-right"
            (click)="removeMergeStep()"
            >
            Zusammenfügungspunkt entfernen
          </button>
        }
      </div>
    }
  </div>
}

<div class="row whitelist-item">
  <div class="col-lg-12">
    @if (startStopButtonsVisible) {
      <div>
        @if (step.state === 2) {
          <button type="button" class="btn btn-success btn-sm pull-right" (click)="stopStep()">
            Abmelden
          </button>
        }
        @if (step.state === 1) {
          <button type="button" class="btn btn-info btn-sm pull-left" (click)="startStep()">
            Anmelden
          </button>
        }
      </div>
    }
  </div>
</div>

<div>&nbsp;</div>
